<template>
  <div class="imgCon">
    <img :src="imageUr" alt="">
    <div class="tips">
      <div>正在为您生成电子{{ title }}单,请稍后查看。</div>
      <div>您也可以点击下方按钮重新生成</div>
    </div>
    <div class="botButton" @click="download">
      重新生成
    </div>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import Loading from '@/components/Loadings/Loading'
import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    'Loading': Loading
  },
  data() {
    return {
      obj: {},
      switchs: false, // loading
      title: '',
      imageUr: api.imgAllUrlZSB + '/zsbPdfWait.png'
    }
  },
  mounted() {
    this.obj = this.$route.params.obj
    console.log(this.obj, '====')
    if (this.obj.encryptKey && this.obj.endorseNo) {
      this.title = '批'
    } else {
      this.title = '保'
    }
  },
  methods: {
    download() {
      this.getStatus()
    },
    getStatus() {
      const headers = {
        headers: {
          Authorization: this.obj.token
        }
      }
      const data = {
        policyNos: [this.obj.policyNo]
      }
      this.switchs = true
      this.$http.post(api.reMakeEpolicy, data, headers)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            if (res.data.data[0].status === '1') {
              if (this.obj.encryptKey && this.obj.endorseNo && (this.obj.channelCode === 'DP_WXMP' || this.obj.channelCode === 'DP_ZYB')) {
                this.getCarEndorsement()
              } else {
                this.obj.orderEncryptKey ? this.getElePolicy() : this.getZsb()
              }
            } else {
              this.$toast('请点击下方按钮重新生成')
            }
          } else {
            this.$toast('请点击下方按钮重新生成')
          }
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
          this.$toast('请点击下方按钮重新生成')
        })
    },
    getElePolicy() {
      if (this.obj.orderNo && this.obj.token) {
        const headers = {
          headers: {
            Authorization: this.obj.token
          }
        }
        const data = {
          orderDto: {
            businessNo: this.obj.orderNo,
            encryptKey: this.obj.orderEncryptKey
          },
          serviceName: this.obj.channelCode
        }
        this.switchs = true
        this.$http.post(api.elePolicyBatchDownloadWithCheck, data, headers).then((res) => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            if (res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList && res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList.length > 0) {
              const ePolicyDtoList = res.data.elePolicyBatchDownloadInfoDto.elePolicyDownloadInfoDtoList
              console.log(ePolicyDtoList, 'this.ePolicyDtoList')
              console.log(this.obj.index, '=====')
              const path = ePolicyDtoList[this.obj.index].downloadPath
              // window.open(path)
              checkFormat.downloadFile(path, this.obj.token, this.obj.riskName)
            }
          } else {
            // this.$toast(res.data.rtnMsg)
            this.getZsb()
          }
        })
          .catch(error => {
            this.switchs = false
            console.log(error)
          })
      }
    },
    getZsb() { // 紫属保
      if (this.obj.orderId && this.obj.orderNo && this.obj.token) {
        const headers = {
          headers: {
            Authorization: this.obj.token
          }
        }
        const data = {
          fileContentFlag: '0',
          orderId: this.obj.orderId
        }
        this.switchs = true
        this.$http.post(api.queryOrderDetail_ZSB, data, headers)
          .then((res) => {
            this.switchs = false
            if (res.data.rtnCode === '0000') {
              if (res.data.data.elePolicy && res.data.data.elePolicy.length) {
                const ePolicyDtoList = res.data.data.elePolicy
                console.log(ePolicyDtoList, 'this.ePolicyDtoList')
                console.log(this.obj.index, '=====')
                const path = ePolicyDtoList[this.obj.index].downloadPath
                // window.open(path)
                checkFormat.downloadFile(path, this.obj.token, this.obj.riskName)
              }
            } else {
              this.$toast(res.data.rtnMsg)
            }
          })
          .catch(error => {
            this.switchs = false
            console.log(error)
          })
      }
    },
    getCarEndorsement() {
      if (this.obj.endorseNo && this.obj.encryptKey && this.obj.token) {
        const data = {
          endorseNo: this.obj.endorseNo,
          encryptKey: this.obj.encryptKey
        }
        const headers = {
          headers: {
            Authorization: this.obj.token
          }
        }
        this.switchs = true
        this.$http.post(api.queryCarEndorseDetail, data, headers)
          .then((res) => {
            this.switchs = false
            if (res.data.rtnCode === '0000') {
              if (res.data.data && res.data.data.queryEndorseInfoDetailRespVO.riskName && res.data.data.eleEndorseDownloadDto && res.data.data.eleEndorseDownloadDto.downloadPath) {
                const ePolicyDtoList = []
                ePolicyDtoList.push(res.data.data.eleEndorseDownloadDto)
                const path = ePolicyDtoList[this.obj.index].downloadPath
                // window.open(path)
                checkFormat.downloadFile(path, this.obj.token, this.obj.riskName)
              }
            } else {
              this.$toast(res.data.rtnMsg)
            }
          })
          .catch(err => {
            this.switchs = false
            console.log(err)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.imgCon{

    width: 100%;
    height: 100vh;
    background: #fff;
    text-align: center;
    img{
        margin-top: 30%;
        width: 1.7rem;
    }
    .tips{
        margin-top: .36rem;
        color: #5F49A1;
        font-size: .12rem;
    }
    .botButton{
        background-color: #6f5cc6;
        font-size: .16rem;
        color: #ffffff;
        margin: .75rem auto 0;
        font-weight: normal;
        border-radius: .08rem;
        padding:.1rem 0;
        width: 52%;
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/Pdf/imgCon/imgCon.vue